module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/060ba568c5b2e96a7fc4d7a9209e79d3.png";